import { useEffect } from 'react';
import IDVC from '@idscan/idvc2';
import { useCustomerAPI } from '../../clients/customer-api/customer-api-client';
import { ecommerceToast } from '../../util/toasts';
import { IDataForSubmit } from '@idscan/idvc2/dist/types/util';
import './license-scan.scss';
import { Typography } from '../../components/typography/typography';

export const LicenseScan = ({ idScanLicenseKey, onSubmit }: { idScanLicenseKey: string; onSubmit: () => void }) => {
  const customerApi = useCustomerAPI();

  const displayLicenseScan = () => {
    const idvc = new IDVC({
      el: 'licenseCapturingEl',
      licenseKey: idScanLicenseKey,
      networkUrl: '/static/idscan/networks',
      resizeUploadedImage: 1200,
      fixFrontOrientAfterUpload: true,
      autoStart: true,
      autoContinue: false,
      isShowDocumentTypeSelect: false,
      useCDN: false,
      showSubmitBtn: true,
      language: 'en',
      realFaceMode: 'none',
      processingImageFormat: 'jpeg',
      allowSubmitWithWarnings: true,
      documentTypes: [
        {
          type: 'DL',
          steps: [
            {
              type: 'front',
              name: 'License Front',
              mode: {
                uploader: true,
                video: true,
              },
            },
            {
              type: 'pdf',
              name: 'License Back',
              mode: {
                uploader: true,
                video: true,
              },
            },
          ],
        },
      ],
      submit(data) {
        handleSubmit(idvc, data);
      },
    });
  };

  const handleSubmit = (idvc: IDVC, licenseData: IDataForSubmit) => {
    if (licenseData.documentType !== 1) {
      console.log('Invalid document type');
      return;
    }

    const frontStep = licenseData.steps.find((item) => item.type === 'front');
    const pdfStep = licenseData.steps.find((item) => item.type === 'pdf');
    if (!(frontStep && pdfStep)) {
      console.log('Invalid steps');
      return;
    }

    idvc.showSpinner(true);

    const frontStepParts = frontStep.img?.split(/:image\/(jpeg|png);base64,/);
    const frontImage = frontStepParts && frontStepParts[2];
    const frontImageMimeType = frontStepParts && `image/${frontStepParts[1]}`;

    const pdfStepParts = pdfStep.img?.split(/:image\/(jpeg|png);base64,/);
    const backImage = pdfStepParts && pdfStepParts[2];
    const backImageMimeType = pdfStepParts && `image/${pdfStepParts[1]}`;
    const rawTrackString = pdfStep && pdfStep.trackString ? pdfStep.trackString : '';

    customerApi
      .scanUserDriverLicense({
        frontImage: frontImage!,
        frontImageMimeType: frontImageMimeType!,
        frontImageAutoCaptured: frontStep.isAuto!,
        backImage: backImage!,
        backImageMimeType: backImageMimeType!,
        backImageAutoCaptured: pdfStep.isAuto!,
        rawTrackString: rawTrackString!,
      })
      .then(() => {
        ecommerceToast('License scanned successfully.', 'success');
        onSubmit();
      })
      .catch((error) => {
        const errorMessage = error.message || 'Error scanning driver license';
        ecommerceToast(errorMessage, 'error');
        idvc.resetAllSteps();
      })
      .finally(() => {
        idvc.showSpinner(false);
      });
  };

  useEffect(() => {
    displayLicenseScan();
  }, []);

  return (
    <div>
      <div className="text-center px-4 mt-4 mb-4">
        <Typography type="text-sm" className="text-grey-500">
          This license is scanned and verified using Quipli Protect. There may be additional security measures run in
          the background.
        </Typography>
      </div>
      <div id="licenseCapturingEl"></div>
    </div>
  );
};
